import { useForm } from 'react-hook-form';

import { SectionType } from 'sections/TabWrap';
import { EditForm, FormItem } from 'sections/EditForm';
import { EditList } from 'sections/EditList';

import { subCategories } from './data.mock';

const useData = () => {
  const { register } = useForm();

  const data: FormItem[] = [
    {
      name: 'name_en',
      value: 'IN22',
      label: 'Name',
      flag: 'en',
    },
    {
      name: 'name_it',
      value: 'IN22',
      flag: 'it',
    },
  ];

  const sections: SectionType[] = [
    {
      id: 1,
      content: <EditForm onSubmit={() => null} data={data} register={register} />,
    },
    {
      id: 2,
      content: <EditList subCategories={subCategories} />,
    },
  ];

  return {
    sections,
  };
};

export { useData };
